export type ResolvedTheme = "light" | "dark";

export const THEME_MEDIA_QUERY = "(prefers-color-scheme: dark)";

export function getSystemTheme(
  mediaQuery: Pick<MediaQueryList, "matches"> | null | undefined,
): ResolvedTheme {
  return mediaQuery?.matches ? "dark" : "light";
}

export function applyResolvedTheme(
  documentRef: Document | null | undefined,
  resolvedTheme: ResolvedTheme,
): void {
  if (!documentRef) {
    return;
  }

  documentRef.documentElement.dataset.theme = resolvedTheme;
  documentRef.documentElement.style.colorScheme = resolvedTheme;
}
